<template>
  <div :class="tileClass" ref="root" :style="tileFormat">
    <div class="tile--image" v-if="item.image[0].imageUrl">
      <div class="tile--image--back" :style="tileFormat">&nbsp;</div>
      <div class="tile--image--front"><img :src="item.image[0].imageUrl" :alt="item.title" /></div>
    </div>
    
    <div class="tile--pane" v-if="item.type == 'rotate'">
      <div class="tile--inset-image">
        <img :src="insetImage" :alt="item.title" />
      </div>
      <div class="tile--label" :style="labelColor">
        <span>{{item.label}}</span>
      </div>
      <div class="tile--content">
        <div class="tile--left">
          <h3 class="tile--title">{{item.title}}</h3>
          <div class="text" v-html="item.content" />
        </div>
        <div class="tile--right">
          <div class="tile--action" v-if="item.videoId" @click="videoPlay"><div class="button--icon"><PlayIcon/></div><div class="button-text">Click to watch</div></div>
          <div class="tile--action" v-if="item.icon_type == 'chat'" @click="openLink"><div class="button--icon"><ChatIcon/></div><div class="button-text">Click to chat</div></div>
          <div class="tile--action" v-if="item.icon_type == 'link'" @click="openLink"><div class="button--icon"><LinkIcon/></div><div class="button-text">Click to see</div></div>
        </div>
      </div>
    </div>

    <div class="tile--pane standard" v-if="item.type == 'standard'">
      <div class="tile--label">
        <span>{{item.label}}</span>
      </div>
      <div class="tile--content">
        <div class="tile--full-width">
          <h3 class="tile--title">{{item.title}}</h3>
          <div class="text" v-html="item.content" />
          <div class="tile--action" v-if="item.videoId" @click="videoPlay"><div class="button--icon"><PlayIcon/></div><div class="button-text">Click to watch</div></div>
          <div class="tile--action" v-if="item.icon_type == 'chat'" @click="openLink"><div class="button--icon"><ChatIcon/></div><div class="button-text">Click to chat</div></div>
          <div class="tile--action" v-if="item.icon_type == 'link'" @click="openLink"><div class="button--icon"><LinkIcon/></div><div class="button-text">Click to see</div></div>
        </div>
      </div>
    </div>

    <div class="tile--pane fixed" v-if="item.type == 'fixed'">
    </div>


  </div>
</template>

<script>
import { gsap } from "gsap";
import * as ScrollMagic from "scrollmagic";

export default {
  name: "Tile",
  components: {
    PlayIcon: () => import(/* webpackPrefetch: true */ '../assets/svg/play-arrow.svg'),
    ChatIcon: () => import(/* webpackPrefetch: true */ '../assets/svg/chat.svg'),
    LinkIcon: () => import(/* webpackPrefetch: true */ '../assets/svg/arrow.svg'),
  },
  props: {
    item: {
      type: Object,
      default: function() {
        return {};
      }
    },
    format: {
      type: String,
      default: function() {
        return "square";
      }
    }
  },
  data() {
    return {
      errors: [],
      isMounted: false
    };
  },
  mounted() {
    this.init();
    this.animateTile();
  },
  methods: {
    resize() {
      this.tileFormat();
    },
    init() {
      this.isMounted = true;

    },
    animateTile() {
      let controller = new ScrollMagic.Controller();
      let timeline = gsap.timeline();
      let el = this.$refs.root;
      if (el) {
        let w = el.offsetWidth;
        let wrapper = el.querySelector(".tile--image"),
          front = el.querySelector(".tile--image--front"),
          back = el.querySelector(".tile--image--back");
        if (this.item.type !=  'fixed') {
          timeline
            .to(front, { duration: 0.8, rotationY: 180 })
            .to(back, { duration: 0.8, rotationY: 0 }, 0)
            .to(wrapper, { duration: 0.2, opacity: 0 }, 0.6)
            .to(wrapper, { duration: 0.4, z:50}, 0)
            .to(wrapper, { duration: 0.4, z:0}, 0.4);
        }
        switch(this.item.type) {
          case 'rotate': {
            timeline.to(el.querySelector(".tile--pane"), { duration: 0.1, opacity: 1, boxShadow: '3px 0px 5px 0px rgba(138,138,138,1)' }, 0.2);
            timeline.to(el.querySelector(".tile--pane"), { duration: 0.3, rotate: '5deg', transformOrigin: "100% 100%" }, 0.3);
            break;
          }
          case 'standard': {
            let l = el.querySelector(".tile--label");
            if (l) {
                timeline.from(l, { duration: 0.7, x: w + l.offsetWidth  }, 0.2);
            }
            let c = el.querySelector(".tile--content");
            if (c) {
                timeline.from(c, { duration: 0.7, x: w + c.offsetWidth  }, 0);
            }
            break;
          }
          default: {
            //Do nothing
          }
        }

        
      }

      //Wait until the DOM is loaded
      this.$nextTick(() => {
        //let imagesEl = this.$refs.images;

      });

      // let triggerHook = 0.4;

      let offset = screen.height < 769 ? 50 : 100;
      let duration = screen.height < 769 ? 100 : 300;

      let scene = new ScrollMagic.Scene({ // eslint-disable-line no-unused-vars
        triggerElement: el,
        duration: duration,
        offset: offset,
        tweenChanges: true
      })
        .setTween(timeline)
        .addTo(controller);
    },
    videoPlay() {
      this.$store.commit('activeVideo', this.item.videoId)
    },
    openLink() {
      window.open(this.item.link, "_blank");
    }
  },
  computed: {
    tileFormat() {
      let styles = {
        backgroundColor:
          this.item.color && this.item.color.background
            ? this.item.color.background
            : "#ffffff",
        color:
          this.item.color && this.item.color.foreground
            ? this.item.color.foreground
            : "#000000"
      };
      if (this.isMounted && this.format == "square" && this.$refs.root) {
        styles.height = this.$refs.root.offsetWidth + "px";
      }
      if (this.isMounted && this.$refs.root && this.item.type != 'rotate') {
        this.$refs.root.querySelectorAll('.button--icon').forEach((el) => {
          el.style.borderColor = styles.color;
          el.style.fill = styles.color;
        })
      }
      return styles;
    },
    labelColor() {
      return {
        color: this.item.color && this.item.color.foreground
            ? this.item.color.foreground
            : "#000000"
      }
    },
    tileClass() {
      return {
        'tile--item': true,
        'rotate': (this.item.type == 'rotate')
      }
    },
    insetImage() {
      return this.item.inset_image ? this.item.inset_image[0].imageUrl : '';
    }
  }
};
</script>


<style scoped lang="scss">
.tile--item {
  width: 33.33%;
  height: 100%;
  position: relative;
  overflow:hidden;
  @include media("<=phone") {
    width: 100%;
  }

  .tile--pane {
    padding: $base-spacing;
    position: absolute;
    width: 100%;
    height: 100%;
    top: 0;
    left: 0;
    box-sizing: border-box;
  }
  .tile--full-width {
    width: 100%;
  }
  .tile--label {
    text-transform: uppercase;
    margin-left: -$base-spacing;
    margin-bottom: $base-spacing;
    padding: $half-spacing $half-spacing;
    background-color: $color-background-primary;
    color: $color-text-on-background-primary;
    display: inline-block;
  }
  &.rotate {
    overflow: unset;
    .tile--label {
      position: absolute;
      top: $base-spacing;
    }
    .tile--pane {
      background-color: $color-background-white;
      color: $color-text-dark;
    }
  }
  .tile--content {
    width: 100%;
    display: flex;
    > .tile--left {
      width: 75%;
    }
    > .tile--right {
      width: 25%;
      display: flex;
      align-items: center;
    }
    > .tile-full-width {
      width: 100%;
    }
  }
  .tile--image {
    position: relative;
    display: flex;
    width: 100%;
    height: 100%;
  }
  .tile--image--front, .tile--image--back {
    position: absolute;
    width: 100%;
    height: 100%;
    backface-visibility: hidden;
  }
  .tile--image img {
    width: 100%;
  }
  .tile--title {
    padding: 0;
    margin: 0;
  }
  .tile--inset-image {
    width: 100%;
    img {
      width: 100%;
    }
  }
  .tile--action {
    display: flex;
    justify-content: center;
    align-items: center;
    flex-wrap: wrap;
    margin-top: $base-spacing;

  }
  .button--icon {
    @include icon-button;
    svg path {
      fill: inherit;
      
    }
    &:hover {
      transform: scale(1.1);
      svg path {
        fill: inherit;
      }
    }
  }
  .button-text {
    width: 100%;
    text-align: center;
  }
}

@include media ("<=laptop") {
  .tile--item {
    h3.tile--title {
      font-size: $font-size-h4;
      font-weight: bold;
    }
    .tile--label {
      margin-bottom: $half-spacing;
    }
    .button--icon {
      width: 50px;
      height: 50px;
    }
    .button-text {
      font-size: 0.7em;
    }
  }
}

@include media ("<=desktop") {
  .tile--item {
    h3.tile--title {
      font-size: $font-size-h4;
      font-weight: bold;
    }
    .tile--label {
      margin-bottom: $half-spacing;
    }
    .button--icon {
      width: 50px;
      height: 50px;
    }
    .button-text {
      font-size: 0.7em;
    }
  }
}
@include media ("<=tablet") {
  .tile--item {
    width: 50%;
  } 
}

@include media ("<=phone", "portrait") {
  .tile--item {
    width: 100%;
  }
  .tile--hide-on-mobile {
    display: none;
  }
}



</style>